import { Injectable } from '@angular/core';
import {IoService} from './io.service';
import {PipeCover} from '../models';

@Injectable()
export class PipeCoverService extends IoService {
  protected model = PipeCover;
  protected listUrl = '/pipecovers/';
}
